import React, { useState, useEffect } from "react";
import "./SearchLiveClasses.scss";

const SearchLiveClasses = ({ onSearch, categories }) => {
  const [category, setCategory] = useState("");  
  const [searchTerm, setSearchTerm] = useState("");  

  // Call onSearch when category or searchTerm changes
  useEffect(() => {
    onSearch(category, searchTerm);
  }, [category, searchTerm, onSearch]);

  // Handler for category selection change
  const handleCategoryChange = (event) => {
    const newCategory = event.target.value === "All Categories" ? "" : event.target.value;
    setCategory(newCategory);
  };

  // Handler for search input change
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <div className="search-live-classes-container">
      <select value={category} onChange={handleCategoryChange}>
        <option value="All Categories">All Class Types</option>
        {categories.map((cat) => (
          <option key={cat} value={cat}>
            {cat}
          </option>
        ))}
      </select>
      <input
        type="search"
        placeholder="Search for Live Classes"
        value={searchTerm}
        onChange={handleSearchChange}
      />
    </div>
  );
};

export default SearchLiveClasses;
